import { render, staticRenderFns } from "./ProductToWithdrawCol.vue?vue&type=template&id=36c30230&scoped=true"
import script from "./ProductToWithdrawCol.vue?vue&type=script&lang=ts"
export * from "./ProductToWithdrawCol.vue?vue&type=script&lang=ts"
import style0 from "./ProductToWithdrawCol.vue?vue&type=style&index=0&id=36c30230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c30230",
  null
  
)

export default component.exports